import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/print.css';
import { registerServiceWorker } from './utils/push';

// The service worker exists only for browser push. Registering it eagerly
// (rather than on first subscribe) means a device that opted in earlier keeps
// receiving after the app is updated.
registerServiceWorker();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
